export default __webpack_public_path__ + "static/media/pagenotfound.5092485b.svg";